import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import { useForm, Controller } from 'react-hook-form';
import {
  FormControl,
  Grid,
  FormLabel,
  Select,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputLabel,
  TextField,
  Checkbox,
  MenuItem,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Swal from 'sweetalert2';

import { Modal } from 'react-bootstrap';
import request from '../../../services/Request';

import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function AddShoppingCartModal(props) {
  const { data, setReflesh, reflesh, id, setMobile, ...rest } = props;
  const defaultValues = {
    machine: data?.add_to_cart?.machine?._id ? data.add_to_cart.machine : null,
    prods: data?.add_to_cart?.products?.length > 0 ? data?.add_to_cart.products : [],
  };
  const { handleSubmit, reset, watch, control, register, setValue } = useForm({ defaultValues });

  const watchAll = watch();

  const [machines, setMachines] = useState([]);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (props.show) {
      request({
        method: 'post',
        url: `/machines/getMachineSelect`,
        data: {
          email: id,
          select: 'member',
        },
      })
        .then((res) => {
          console.log('machines', res.data);
          setMachines(res.data);
          // setProducts(res.data);
        })
        .catch((err) => {
          setMachines([]);
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: err?.response?.data?.message || `download machines error`,
          });
        })
        .finally(() => {
          console.log('defaultValues', defaultValues);
          reset(defaultValues);
        });
    }
  }, [props.show]);

  useEffect(() => {
    const findindex = machines.findIndex((e) => e._id === watchAll?.machine?._id);
    console.log('findindex', machines[findindex]);
    let uniqueProducts = [];
    if (findindex >= 0) {
      let pdArray = machines[findindex].product;
      let bundleArray = machines[findindex].products_bundle;
      if (bundleArray?.length > 0) {
        bundleArray = bundleArray.map((bd) => {
          return {
            id: bd,
          };
        });
      }

      let productArray = [...pdArray, ...bundleArray];

      if (productArray?.length > 0) {
        uniqueProducts = Array.from(new Set(productArray.map((p) => p.id._id))).map((id) =>
          productArray.find((p) => p.id._id === id)
        );
      }
    }
    //filter same products
    setProducts(uniqueProducts);
    // console.log('watall.machine', watchAll?.machine);
    // console.log('data?.add_to_cart?.machine', data?.add_to_cart?.machine);
    if (watchAll?.machine?._id !== data?.add_to_cart?.machine?._id) {
      setValue('prods', []);
    }
  }, [watchAll?.machine]);

  const onSubmit = async (formData) => {
    let prods = [];
    if (formData.prods.length > 0) {
      prods = formData.prods.map((p) => {
        return {
          id: p.id,
        };
      });
    }

    if (formData.machine === null) {
      prods = [];
    }

    const _id = data?._id ? data?._id : id;
    const isAll = data?._id ? false : true;

    //check is product contain bundles
    console.log('prods', prods);
    if (prods?.length > 1) {
      let isBundle = false;
      prods.forEach((p) => {
        if (p?.id?.prodType === 'bundle') {
          isBundle = true;
        }
      });
      if (isBundle) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'You can not add 1 bundle to cart',
        });
        return;
      }
    }

    request({
      method: 'post',
      url: `/clientUser/clientUserAddToCart`,
      data: {
        _id: _id,
        machine: formData.machine,
        products: prods,
        isAll: isAll,
        created_by_admin: true,
      },
    })
      .then(() => {
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Product added to cart',
        }).then(() => {
          setReflesh(!reflesh);
          props.onHide();
        });
      })
      .catch((err) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: err?.response?.data?.message || `add to cart error`,
        });
      });
    console.log('formData', formData);
    console.log('rowdata,', data);
  };

  return (
    <Modal className="modal-w" {...rest} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{`Add Product To Member ${
          data?.username || '(ALL)'
        }`}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <form
          onSubmit={handleSubmit(onSubmit)}
          noValidate
          style={{ textAlign: 'center', padding: '0 40px' }}
        >
          <div
            style={{ display: 'flex', alignItems: 'center', gap: '10px', flexDirection: 'column' }}
          >
            <div style={{ width: '100%', marginTop: '30px' }}>
              <Controller
                name="machine"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    //  value={prodValue}
                    options={machines}
                    value={watchAll.machine}
                    onChange={(event, value) => {
                      //  setProdValue(value);
                      field.onChange(value);
                    }}
                    getOptionSelected={(option, value) => option.name === value.name}
                    getOptionLabel={(option) => option.name + '(' + option.description + ')'}
                    renderOption={(option, { selected }) => (
                      <React.Fragment>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.name + '(' + option.description + ')'}
                      </React.Fragment>
                    )}
                    fullWidth
                    renderInput={(params) => (
                      <TextField {...params} variant="outlined" label="Machine" />
                    )}
                  />
                )}
              />
            </div>
            {products?.length > 0 && (
              <div style={{ width: '100%', marginTop: '30px' }}>
                <Controller
                  name="prods"
                  control={control}
                  render={({ field }) => (
                    <Autocomplete
                      multiple
                      options={products}
                      value={watchAll.prods || []}
                      disableCloseOnSelect
                      onChange={(event, value, reason) => {
                        if (reason === 'select-option') {
                          // Allow duplicates by manually appending the selected item
                          const newValue = [...watchAll.prods, value[value.length - 1]];

                          if (newValue.length > 3) {
                            Swal.fire({
                              icon: 'error',
                              title: 'Oops...',
                              text: 'You can add only 3 products',
                            });
                          } else {
                            field.onChange(newValue);
                          }
                        } else if (reason === 'remove-option') {
                          // Remove items when unchecked
                          field.onChange(value);
                        }
                      }}
                      getOptionSelected={() => false} // Ensures no item is "checked"
                      getOptionLabel={(option) => option.id?.name?.en}
                      renderOption={(option) => (
                        <React.Fragment>
                          {option.id?.name?.en + ' (' + option.id?.upc + ')'}
                        </React.Fragment>
                      )}
                      fullWidth
                      renderInput={(params) => (
                        <TextField {...params} variant="outlined" label="Add Products" />
                      )}
                    />
                  )}
                />
              </div>
            )}
          </div>

          <Button variant="contained" color="primary" type="submit" className="mt-3">
            Submit
          </Button>
        </form>
      </Modal.Body>
    </Modal>
  );
}
